import { Link } from "react-router-dom";

export default function CTA() {
  return (
    <section id="cta" className="px-3 md:px-5 py-10 md:py-16">
      <div className="relative h-[80vh] min-h-[560px] rounded-[28px] overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20editorial%20wide%20shot%20of%20a%20serene%20sunlit%20home%20entryway%20with%20cream%20walls%20wooden%20bench%20linen%20throw%20and%20small%20olive%20tree%20in%20terracotta%20pot%2C%20warm%20golden%20hour%20light%20pouring%20through%20open%20doorway%20creating%20long%20soft%20shadows%2C%20editorial%20interior%20photography%20premium%20neutral%20warm%20palette%20calm%20atmosphere&width=2000&height=1300&seq=cta-pure-2026&orientation=landscape"
          alt="Welcoming home entryway"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-foreground-950/40 via-foreground-950/15 to-foreground-950/55"></div>

        <div className="relative z-10 h-full w-full flex flex-col justify-between p-6 md:p-12 lg:p-16">
          <div className="max-w-2xl">
            <h2 className="font-heading text-background-50 text-4xl md:text-6xl lg:text-7xl font-medium leading-[1.05] lowercase">
              come home to<br />a quieter mind.
            </h2>
          </div>

          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <Link
              to="/booking"
              className="group inline-flex items-center justify-between gap-3 bg-background-50 text-foreground-950 pl-6 pr-2 py-2.5 rounded-full w-fit hover:bg-background-100 transition-colors"
            >
              <span className="text-sm font-medium whitespace-nowrap">Start booking</span>
              <span className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-950 text-background-50">
                <i className="ri-arrow-right-line"></i>
              </span>
            </Link>

            <p className="text-background-100 text-sm md:text-base leading-relaxed max-w-xs md:text-right">
              First visit in as little as 24 hours.<br />
              No subscription. No commitment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}